<ng-content select="[prefix]"></ng-content>

<input
    #textbox
    kui-input
    type="text"
    class="search__input"
    [disabled]="disabled()"
    [placeholder]="placeholder()"
    [(ngModel)]="searchValue"
    (ngModelChange)="debounceSearch($event)"
/>

@if (searchValue()) {
    <button kui-button color="danger" class="search__button search__button--clear" (click)="clear.emit()">
        <kui-icon name="close"></kui-icon>
    </button>
} @else {
    <button kui-button color="secondary" class="search__button search__button--submit" (click)="submitSearch.emit(searchValue())">
        <kui-icon name="search"></kui-icon>
    </button>
}

<ng-content select="[suffix]"></ng-content>
